import { render, staticRenderFns } from "./ProductPieChart.vue?vue&type=template&id=6f479fc3&scoped=true&"
import script from "./ProductPieChart.vue?vue&type=script&lang=js&"
export * from "./ProductPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f479fc3",
  null
  
)

export default component.exports